import React from 'react';
import { Radio } from 'antd';
import { RadioChangeEvent } from 'antd/lib/radio';
import styled, { css } from 'styled-components';

interface IRadioItem {
  title: string;
  value: string;
  disabled: boolean;
}

interface IProps {
  radioItems: Array<IRadioItem>;
  onChange?(e: RadioChangeEvent): void;
  value?: number | string;
}

export const RadioGroup = ({ radioItems, onChange, value }: IProps) => (
  <RadioContainer onChange={onChange} value={value}>
    {radioItems.map(({ value: itemValue, disabled, title }) => {
      return (
        <Radio key={itemValue} disabled={disabled} value={itemValue}>
          {title}
        </Radio>
      );
    })}
  </RadioContainer>
);

const RadioContainer = styled(Radio.Group)`
  ${({
    theme: {
      radioGroupItemBorderColor,
      radioGroupItemActiveBorderColor,
      radioGroupItemActiveBgColor,
      radioGroupItemActivePointerColor,
      radioGroupItemTitleColor,
    },
  }) => css`
    display: inline-flex;
    width: 100%;

    & .ant-radio-wrapper {
      font-family: 'Raleway', sans-serif;
      font-weight: 600;
      font-size: 14px;
      color: ${radioGroupItemTitleColor};
      width: 100%;
      align-self: center;

      &:last-child {
        margin-right: 0;
      }
    }

    & .ant-radio {
      vertical-align: top;
      top: 0;

      &:hover .ant-radio-inner {
        border-color: ${radioGroupItemActiveBorderColor};
      }
    }

    & span.ant-radio + * {
      padding-right: 0;
      padding-left: 16px;
      display: inline-block;
      vertical-align: middle;
    }

    & .ant-radio-inner {
      width: 24px;
      height: 24px;

      &:after {
        top: 5px;
        left: 5px;
        width: 12px;
        height: 12px;
      }
    }

    & .ant-radio-inner {
      border-color: ${radioGroupItemBorderColor};
    }

    & .ant-radio-checked .ant-radio-inner {
      border-color: ${radioGroupItemActiveBorderColor};
      background-color: ${radioGroupItemActiveBgColor};

      &:after {
        background-color: ${radioGroupItemActivePointerColor};
      }
    }

    & .ant-radio-disabled .ant-radio-inner {
      background-color: transparent;
    }

    .ant-radio-wrapper:hover .ant-radio,
    .ant-radio:hover .ant-radio-inner,
    .ant-radio-input:focus + .ant-radio-inner {
      border-color: ${radioGroupItemActiveBorderColor};
    }
  `}
`;
